import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { combineLatest, Observable, of, Subscription } from "rxjs";
import { DataService } from "../../../services/data.service";
import { ActivatedRoute, Router } from "@angular/router";
import { debounceTime, distinctUntilChanged, filter, map, switchMap, tap } from "rxjs/operators";
import {
  NgbCalendar,
  NgbDate,
  NgbDateStruct,
  NgbInputDatepicker,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbTypeaheadSelectItemEvent
} from "@ng-bootstrap/ng-bootstrap";
import * as moment from 'moment';
import 'moment-duration-format';
import * as L from 'leaflet';
import { gridLayer, latLng, tileLayer } from 'leaflet';
import 'leaflet-editable';
import 'leaflet.gridlayer.googlemutant';
import 'leaflet-routing-machine';
import 'leaflet-geometryutil';
import 'leaflet.markercluster';
import { CustomAdapter, CustomDateParserFormatter } from "../../_shared/ngbdatepickeradapter/datepicker-adapter";


type ChartCfg = {
  id: string,
  api: string,
  label: string,
  params: any
};

@Component({
  selector: 'app-trips',
  templateUrl: './trips.component.html',
  styleUrls: ['./trips.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class TripsComponent implements OnInit {
  //todo: dynamic chart shrink on desktop

  sort = {
    column: '',
    asc: 1
  };

  indgroup: number = 1;

  targetAudience: string = 'Target Audience';
  timeInterval: string = 'Time Interval';

  generalMenu = [];

  from: NgbDate;
  until: NgbDate;

  system: string;

  map: L.DrawMap;
  menu = [];

  leafletOptions: any;
  tiles: any[] = [];

  isMapOpen = false;

  trips: any[] = [];
  selected: any = null;

  flattenLegend = {};
  layergroup: L.LayerGroup;
  routing: L.Routing.Control;

  filterLegends = [];

  users: any[] = [];
  groups: any[] = [];
  search: (text: Observable<string>) => Observable<readonly any[]>

  target: any;

  private _domain: string;
  private _type: string;

  domains: string[] = [];
  loader: boolean = true;
  error: string = "";
  errorFound: boolean = false;

  pageSize = 10;
  p = 1;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private calendar: NgbCalendar
  ) { }

  ngOnInit(): void {
    this.system = this.dataService.project.systems[0].system_type;
    this.search = (text$: Observable<string>) => text$.pipe(
      // debounceTime(200),
      distinctUntilChanged(),
      // filter(term => term.length >= 2),
      map(term => {

        if (term.length < 2) {
          return [{ prefix: 'Group', label: `All`, value: { community_id: null, user_id: null } }];
        }

        const users = this.users.filter(x => x).map(user => ({ prefix: 'User', label: `${user.first_name} ${user.last_name}`, value: { user_id: user.user_id, community_id: null } }));
        const groups = this.groups.filter(x => x).map(group => ({ prefix: 'Group', label: `${group.name}`, value: { community_id: group.id, user_id: null } }));
        return [...groups, ...users].filter(item => item.label.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1);
      })
    )
    this.dataService.getProjectConfigurationGeneral().pipe(
      tap(config => this.init(config)),
      switchMap(() => this.loadUsers()),
      switchMap(() => this.route.queryParams)
    ).subscribe(params => {
      this.loader = true
      this._type = params.type || 'general';
      this._domain = params.domain || this.domains[0];

      this.until = this.str2NgbDate(params.until, this.calendar.getToday());
      this.from = this.str2NgbDate(params.from, this.calendar.getPrev(this.calendar.getToday(), 'm', 1));

      if (!params.user_id && !params.community_id) {
        const user = this.users[0];
        this.target = { prefix: 'User', label: `${user.first_name} ${user.last_name}`, value: { user_id: user.user_id, community_id: null } };
      } else if (params.user_id) {
        const user = this.users.find(u => u.user_id == params.user_id);
        this.target = { prefix: 'User', label: `${user.first_name} ${user.last_name}`, value: { user_id: user.user_id, community_id: null } };
      } else if (params.community_id) {
        const group = this.groups.find(g => g.id == params.community_id);
        this.target = { prefix: 'Group', label: `${group.name}`, value: { community_id: group.id, user_id: null } };
      }
      this.errorFound = false;
      this.dataService.getTrips(
        params.user_id ? params.user_id : this.users[0].user_id,
        null,
        true,
        true,
        this.ngbDate2Str(this.from),
        this.ngbDate2Str(this.until)
      ).subscribe(result => {

        console.log(result);
        this.flattenLegend = {};

        let tripIds = [];
        this.trips = this.sortItems('date', -1, result.map(e => {
          tripIds.push(e.trip_uuid);
          return {
            ...e,
            date: moment(e.trip_start).format('DD/MM/YYYY'),
            start: moment(e.trip_start).format('HH:mm'),
            end: moment(e.trip_end).format('HH:mm'),
            durationStr: moment.duration(e.duration, 'seconds').format('hh:mm:ss')
          }
        }));

        this.menu.forEach(m => {
          let key = m.label;
          m.children.forEach(mm => {
            mm.children.forEach(mmm => {
              const key = `${m.label}/${mm.label}/${mmm.label}`;
              if (typeof this.flattenLegend[key] === 'undefined') {
                this.flattenLegend[key] = {
                  'info': {
                    icon: mmm.icon,
                    color: mm.color
                  }
                };
              }
            })
          })
        });
        this.loader = false;

      },
        error => {
          this.error = error.error.message;
          this.loader = false;
          this.errorFound = true;
        })
    });
  }

  pageChanged($event: number) {
    this.p = $event;
  }

  getPages() {
    return Math.ceil(this.filterTrips().length / this.pageSize);
  }

  selectTrip(trip) {
    this.selected = trip;
    this.setParamInfo();
  }

  setParamInfo() {
    this.menu.forEach(m => {
      m.children.forEach(mm => {
        mm.children.forEach(mmm => {
          mmm.count = this.selected.events.filter(e => e.param == mm.label && e.subparam == mmm.label).length;
          mmm.score = this.selected[this.domain][mm.label][mmm.label].score ? this.selected[this.domain][mm.label][mmm.label].score : 0;
        })
      })
    })
  }

  setMapOpen(open, trip) {
    this.filterLegends = [];
    this.selected = trip;
    this.setParamInfo();
    this.isMapOpen = open;
  }

  filterTrips() {
    return this.sortItems(this.sort.column, this.sort.asc, this.trips);
  }

  onFilterChange(event) {
    const params = event.target.value.split('/');
    const key = `${this.domain}/${params[0]}/${params[1]}`;
    let temp = [...this.filterLegends];
    if (event.target.checked && temp.indexOf(key) === -1) {
      temp.push(key);
    }
    else if (!event.target.checked && temp.indexOf(key) > -1) {
      const index = temp.indexOf(key);
      temp.splice(index, 1);
    }
    this.filterLegends = temp;
  }

  private str2NgbDate(str: string, def: NgbDate) {
    if (str) {
      const dd = str.split('/');
      return {
        year: parseInt(dd[2]),
        month: parseInt(dd[1]),
        day: parseInt(dd[0])
      } as NgbDate;
    }

    return def;
  }

  private ngbDate2Str(date: NgbDate) {
    return `${date.year}-${date.month}-${date.day}`;
  }

  private init(config: any) {

    const schema = this.dataService.project.configuration.schema;

    for (const key in config[this.system]) {
      const item = config[this.system][key];
      const id = `general/${key}`;

      this.generalMenu.push(this.menuItem(id, item.display_name, item.display_name));
    }

    if (schema.eco_efficiency) {
      this.domains.push('eco_efficiency');
      const eco = this.menuItem('eco', 'eco_efficiency', 'eco_efficiency');
      this.menu.push(eco);

      for (const param in schema.eco_efficiency[this.system].params) {
        const id = `eco/${param}`;

        const paramMenu = this.menuItem(id, param, param, true, null, schema.eco_efficiency[this.system].params[param].color);
        eco.children.push(paramMenu);

        Object.keys(schema.eco_efficiency[this.system].params[param].subparams).map(subparam => {
          const id = `eco/${param}/${subparam}`;
          paramMenu.children.push(this.menuItem(id, subparam, schema.eco_efficiency[this.system].params[param].subparams[subparam].name, false, schema.eco_efficiency[this.system].params[param].subparams[subparam].icon));
        });
      }
    }

    if (schema.safety) {
      this.domains.push('safety');
      const safety = this.menuItem('safety', 'safety', 'safety');
      this.menu.push(safety);

      for (const param in schema.safety.params) {
        const id = `safety/${param}`;

        const paramMenu = this.menuItem(id, param, param, true, null, schema.safety.params[param].color);
        safety.children.push(paramMenu);
        Object.keys(schema.safety.params[param].subparams).map(subparam => {
          const id = `safety/${param}/${subparam}`;
          paramMenu.children.push(this.menuItem(id, subparam, schema.safety.params[param].subparams[subparam].name, false, schema.safety.params[param].subparams[subparam].icon));
        });
      }
    }

    if (schema.functioning) {
      this.domains.push('functioning');
      const functioning = this.menuItem('functioning', 'functioning', 'functioning');
      this.menu.push(functioning);

      for (const param in schema.functioning.params) {
        const id = `functioning/${param}`;

        const paramMenu = this.menuItem(id, param, param, true, null, schema.functioning.params[param].color);
        functioning.children.push(paramMenu);

        Object.keys(schema.functioning.params[param].subparams).map(subparam => {
          const id = `functioning/${param}/${subparam}`;
          paramMenu.children.push(this.menuItem(id, subparam, schema.functioning.params[param].subparams[subparam].name, false, schema.functioning.params[param].subparams[subparam].icon));
        });
      }
    }

  }

  navigate(params: any) {
    this.router.navigate([], { queryParamsHandling: 'merge', queryParams: params });
  }

  private menuItem(id, label, name, collapsed = false, icon = null, color = '#f5a623') {
    return { id, label, name, collapsed, icon, color, children: [] };
  }

  setPeriod(period: string) {
    this.navigate({ period });
  }

  setFrom($event: NgbDate) {
    this.navigate({ from: `${$event.day}/${$event.month}/${$event.year}` });
  }

  setUntil($event: NgbDate) {
    this.navigate({ until: `${$event.day}/${$event.month}/${$event.year}` });
  }

  loadUsers() {
    return this.users.length ? of([]) :
      combineLatest([this.dataService.getProjectRolesUsers(), this.dataService.getProjectGroups()]).pipe(
        tap(([users, groups]) => {
          this.users = users;
          this.groups = groups;
        })
      );
  }


  setTarget($event: NgbTypeaheadSelectItemEvent) {
    console.log($event);
    if ($event) {
      this.navigate($event.item.value)
    } else {
      this.navigate({ user_id: null, community_id: null })
    }
  }

  setTargetUser(user) {
    console.log(user);
    if (user) {
      this.target = { prefix: 'User', label: `${user.first_name} ${user.last_name}`, value: { community_id: null, user_id: user.user_id } };
      this.navigate({ user_id: user.user_id, community_id: null });
    } else {
      this.navigate({ user_id: null, community_id: null })
    }
  }

  set type(value: string) {
    if (this._type != value) {
      this.navigate({ type: value, id: null, domain: null });
    }
  }

  get type(): string {
    return this._type;
  }

  get typeLabel(): string {
    return {
      'general': 'General Indicators',
      'domain': 'Domain Scores',
      'trips': 'Trips'
    }[this._type];
  }

  set domain(value: string) {
    if (this._domain != value) {
      this.navigate({ type: 'domain', id: null, domain: value });
    }
  }

  get domain(): string {
    return this._domain;
  }

  compare(a, b) {
    return a > b ? 1 : a == b ? 0 : -1;
  }

  dateToNum(d) {
    d = d.split("/"); return Number(d[2] + d[1] + d[0]);
  }

  dateCompare(a, b) {
    return this.dateToNum(a) > this.dateToNum(b) ? 1 : this.dateToNum(a) == this.dateToNum(b) ? 0 : -1;
  }

  sortItems(column, asc, array) {
    return array.sort((a, b) => {
      if (!a[column]) {
        a[column] = '';
      }
      if (!b[column]) {
        b[column] = '';
      }
      if (column == 'duration') {
        return this.compare(a[column], b[column]) * asc;
      }
      else if (column == 'date') {
        return this.dateCompare(a[column], b[column]) * asc;
      }
      else if (column == 'distance') {
        return this.compare(a[column], b[column]) * asc;
      }
      else {
        return a[column].localeCompare(b[column]) * asc;
      }
    });
  }

  toggleSort(field: string) {
    if (this.sort.column != field) {
      this.sort.column = field;
      this.sort.asc = 1;
    } else {
      this.sort.asc *= -1;
    }
  }

}
